const CONSTANTS = {
  BREAKPOINTS: {
    DESKTOP: 'desktop',
    TABLET: 'tablet',
    MOBILE: 'mobile',
    WIDESCREEN: 'widescreen',
    FULLHD: 'fullhd',
    TOUCH: 'touch',
  },
  COLORS: {
    PRIMARY: 'primary',
    LINK: 'link',
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    DANGER: 'danger',
    DARK: 'dark',
    TEXT: 'text',
  },
  COLOR_VARIANT: {
    light: 'light',
    dark: 'dark',
  },
};

export default CONSTANTS;
